import { t } from "i18next";
import React from "react";

const NoData = () => {
  return (
    <app-no-data
      _ngcontent-serverapp-c3068904919
      _nghost-serverapp-c3327265799
      className="ng-tns-c3068904919-124 ng-star-inserted"
    >
      <div _ngcontent-serverapp-c3327265799 className="no-result">
        <div _ngcontent-serverapp-c3327265799 className="pic">
          <video
            _ngcontent-serverapp-c3327265799
            drccdnvideo
            autoPlay
            preload
            playsInline
            loop
            poster={"/assets/Loader/no-data.png"}
            className="ng-star-inserted"
          >
            <source
              _ngcontent-serverapp-c3327265799
              type="video/quicktime"
              drccdnsrc="/assets/images/animation/no-data.mov"
              src={"/assets/Loader/no-data.mov"}
            />
            <source
              _ngcontent-serverapp-c3327265799
              type="video/webm"
              drccdnsrc="/assets/images/animation/no-data.webm"
              src={"/assets/Loader/no-data.webm"}
            />
          </video>
        </div>
        <div _ngcontent-serverapp-c3327265799 className="text">
          {t("NoData")}
        </div>
      </div>
    </app-no-data>
  );
};

export default NoData;
